import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { useContext } from 'react';
import AppConfig from '../../../../core/AppConfig';
const withAppConfig = Component => {
    const Hoc = props => (<Component {...props} appConfig={useContext(AppConfig)}/>);
    Hoc.displayName = `withAppConfig(${Component.displayName || Component.name})`;
    return hoistNonReactStatics(Hoc, Component);
};
export default withAppConfig;
